import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/Language.tsx
const LanguageIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M16 10a1 1 0 0 1 .914.594l4 9 .036.095a1 1 0 0 1-1.817.808l-.047-.09L18.46 19h-4.922l-.625 1.406a1 1 0 0 1-1.828-.812l4-9 .07-.13A1 1 0 0 1 16 10Zm-1.572 7h3.144L16 13.463 14.428 17ZM8 3a1 1 0 0 1 2 0v1h1a1 1 0 1 1 0 2H9.963c-.143 1.98-.706 3.789-1.58 5.187-.029.046-.06.092-.091.138.864.357 1.926.6 3.11.663l.323.012.101.008a1 1 0 0 1-.049 1.99l-.101.002-.376-.015c-1.644-.086-3.164-.474-4.388-1.093C6.082 13.574 5.1 14 4 14a1 1 0 1 1 0-2c.39 0 .793-.11 1.188-.336C4.474 10.94 4 10.041 4 9a1 1 0 0 1 2 0c0 .38.177.818.604 1.254.027-.042.056-.083.083-.127.66-1.055 1.13-2.49 1.269-4.127H4a1 1 0 0 1 0-2h4V3Z",
		fill: props.fill || "currentColor"
	})
}));
export { LanguageIcon };
